import * as formik from "formik";
import * as yup from "yup";
import {Button, Card, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import {useContext, useReducer, useState} from "react";
import {BackendContext, BackendDispatchContext} from "../../../context/Backend";
import {redirect, redirectDocument, useNavigate} from "react-router";
import {useSubmit} from "react-router-dom";
import {useTranslation} from "react-i18next";
import "../../../App.css"
import styles from "../../usermanagement/usermanagement.module.css";

const LoginForm = (props) => {

    const backendDispatch = useContext(BackendDispatchContext);
    const backend = useContext(BackendContext);
    const submit = useSubmit();
    const {t} = useTranslation();

    const [error, setError] = useState("");
    const navigate = useNavigate();

    const { Formik } = formik;

    const schema = yup.object().shape({
        login: yup.string().required(),
        password: yup.string().required()
    });

    return (
        <Formik
            validationSchema={schema}
            onSubmit={(formData, actions) => {
                backend.api.login(formData, (ret) => {
                    backendDispatch({type: 'hasLoggedIn', roles: ret.roles});
                    submit(null, {method: "post", action: "/"})
                    navigate("/");
                }, (error) => {
                    let message = '';
                    switch (error.data?.message) {
                        case 'login_failed':
                            message = t('login.loginFailed');
                            break;
                        case 'login_forbidden_error':
                        case 'login_nomanager':
                            message = t('login.loginPermissions');
                            break;
                        case 'login_failed_banned':
                            message = t('login.loginBanned');
                            break;
                        default:
                            message = t('login.loginFailed');
                    }
                    setError(message);
                    actions.setSubmitting(false);
                });

            }}
            initialValues={{
                login: '',
                password: ''
            }}
        >
            {({
                  handleSubmit, handleChange, values, touched,
                  errors, isSubmitting
              }) => (
                <Form onSubmit={handleSubmit} autoComplete={"off"}>
                    <div className={"inputContainer"}>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="login"
                                        className={styles.label}>{t('login.loginField')}</Form.Label>
                            <Form.Control type="text" name={"login"}
                                          onChange={handleChange}
                                          value={values.login} isInvalid={!!errors.login}/>
                        </Form.Group>
                    </div>
                    <div className={"inputContainer"}>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="password"
                                        className={styles.label}>{t('login.passwordField')}</Form.Label>
                            <Form.Control type="password" name={"password"}
                                          onChange={handleChange}
                                          autoComplete={"current-password"}
                                          value={values.password} isInvalid={!!errors.password}/>
                        </Form.Group>
                    </div>
                    <div className="d-grid gap-2">
                        <Button className={"websobutton"} variant={"primary"} type="submit">
                            {isSubmitting ? (<Spinner
                                className={"me-2"}
                                as="span"
                                animation="border"
                                size="sm"

                            />) : null}
                            {t('login.loginButton')}
                        </Button>
                        <span className={"text-danger-emphasis"}>{error}</span>
                    </div>
                </Form>
            )}
        </Formik>);

};

export default LoginForm;